module.exports = __webpack_public_path__ + "img/Mask-Watercolor.76eaece8.png";